import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-log-out",
  "use": "icon-log-out-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-log-out\"><path d=\"M16.3639 18.3637C12.8492 21.8784 7.15074 21.8784 3.63602 18.3637C0.121304 14.849 0.121304 9.15051 3.63602 5.63579C7.15074 2.12108 12.8492 2.12108 16.3639 5.63579\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M20 9L22.6667 12L20 15\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M22.5 12L10 12\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol